const getters = {
    username: state => state.user.username,
    Authorization: state => state.user.Authorization,
    token: state => state.user.token,
    Loading: state => state.Loading.loading,
    router: state => state.Jurisdiction.Public_router,
    usertype: state => state.user.user_type,
    alljd: state => state.Jurisdiction.all_Jurisdiction,
	systemname: state => state.user.system_name,
	systemlogo: state => state.user.system_logo,
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js